import React, { useState, useEffect, forwardRef } from "react";
import FullCalendar, { constrainPoint } from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import interactionPlugin from '@fullcalendar/interaction'; // a plugin!
import { ko } from "date-fns/locale";
import {
    Box, Select, MenuItem, FormControl, InputLabel, Dialog,
    AppBar, Toolbar, IconButton,
    Typography, Button, alertTitleClasses
} from "@mui/material";
import CenterSelect from "./CenterSelect";
import { configState, loginState } from "../lib/State";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import axios from "axios";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import moment from "moment";
import add_comma from "../lib/add_comma";
import remove_comma from "../lib/remove_comma";
import Slide from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";
import pr from "../lib/pr";
import styled from "@emotion/styled";
import { brown, green, blue, orange, purple, red } from '@mui/material/colors';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper
} from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import ReportCardDialogStat from './ReportCardDialogStat';
import ReportCardDialogList from "./ReportCardDialogList";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const token = get_token();
const cid = get_cid();

const Container = styled(Box)`
    padding: 10px;
    .MuiTableHead-root .MuiTableRow-root { background:${brown[200]} } /* 제목 셀 */
    .MuiTableHead-root .MuiTableCell-root { text-align: center; color: white; } 
    .MuiTableBody-root .MuiTableCell-root { text-align: center; padding:0 ;} 
    .green { background: ${green[500]} }
    .blue { background: ${blue[500]} }
    .orange { background: ${orange[500]} }
`;

export default function ReportBuyDialog(props) {

    const { open, setOpen, tcid, login, sdate, edate } = props;
    const [mode, setMode] = useState(1); //1.list 2.statistics

    const onClose = () => {
        setMode(1);
        setOpen(false);
    }

    // {
    //     id: 27721,
    //     regdate: '2022-10-24 01:52',
    //     name: '박준수',
    //     phone: '010-3363-3776',
    //     gubun: '클래스쿠폰',
    //     itemName: '클래스 12회권',
    //     sdate: '2022-10-24',
    //     edate: '2022-11-22',
    //     amount: 148600,
    //     amountf: '148,600',
    //     method: '카드(온라인)',
    //     cname: '두써킷 아주점',
    //     location: '아주점',
    //     term: '2022-10-24 ~ 2022-11-22',
    //     pt_count: 12,
    //     fcname: ''
    //   }

    return <Dialog
        open={open}
        TransitionComponent={Transition}
        onClose={onClose}
        PaperProps={{
            style: {
                minHeight: '70%',
                minWidth: '60%'
            }
        }}
    >
        <AppBar sx={{ position: "static" }}>
            <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                    <Typography style={{ fontSize: 18 }}>내역보기</Typography>
                </Box>
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={onClose}
                    aria-label="close"
                >
                    <CloseIcon />
                </IconButton>
            </Toolbar>
        </AppBar>

        <Box p={1} display="flex" justifyContent="space-between" alignItems="center">
            <Box>
                <Box pl={1}>조회기간 : {sdate} ~ {edate}</Box>
            </Box>
            <Box display="flex">
                <Box mr={1}><Button variant="contained" onClick={() => setMode(1)}>목록보기</Button></Box>
                <Box mr={1}><Button variant="contained" onClick={() => setMode(2)}>요약보기</Button></Box>
            </Box>
        </Box>

        {/* 목록 / 요약 */}
        {mode === 1 ? <ReportCardDialogList login={login} cid={cid} tcid={tcid} sdate={sdate} edate={edate}></ReportCardDialogList>
            : <ReportCardDialogStat login={login} cid={cid} tcid={tcid} sdate={sdate} edate={edate}></ReportCardDialogStat>
        }

    </Dialog >
}